export function getEditLegacyUserRoute(userId: string) {
	return `/legacy-users/edit/${userId}`;
}

export function getPatientLegacyHospitalizationRoute(sponsorMrn: string, stayUuid: string) {
	return `/patienthospitalizations/${sponsorMrn}/${stayUuid}`;
}
